import { fetchApi } from 'src/_helpers/client/fetchApi'
import { buildUrl } from 'src/_helpers/buildUrl'

const PATH = '/api/open/journal_issues'

async function getByUuid(uuid) {
  if (!uuid) {
    return null
  }

  const url = `${PATH}/${uuid}`

  return await fetchApi(
    url,
    'GET',
    { accept: 'application/json' },
    { next: { tags: [`journal_issues:${uuid}`] } },
  ).then(
    (response) => response,
    (error) => {
      if (error?.status === 404) {
        return null
      }

      throw new Error(`Failed to fetch journal issue: ${url}`)
    },
  )
}

async function getBySlug(journalUuid, slug, locale) {
  if (!journalUuid || !slug || !locale) {
    return null
  }

  const url = `${PATH}/${locale}/${journalUuid}/${encodeURIComponent(slug)}`

  return await fetchApi(
    url,
    'GET',
    { accept: 'application/json' },
    { next: { tags: [`journal_issues:${locale}:${journalUuid}:${slug}`] } },
  ).then(
    (response) => response,
    (error) => {
      if (error?.status === 404) {
        return null
      }

      throw new Error(`Failed to fetch journal issue: ${url}`)
    },
  )
}

async function getIssuesPageByJournalUuid(journalUuid, page = 1, perPage = 16, filters = {}) {
  if (!journalUuid) {
    return null
  }

  const url = buildUrl(PATH, {
    'iri[journal]': `/api/open/journals/${journalUuid}`,
    page,
    perPage,
    ...filters,
  })

  return await fetchApi(url, 'GET', { accept: 'application/ld+json' }).then(
    (response) => response,
    () => {
      throw new Error(`Failed to fetch entities: ${url}`)
    },
  )
}

export const journalIssueService = {
  getByUuid,
  getBySlug,
  getIssuesPageByJournalUuid,
}
